import React from "react";

// @mui icons
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import EmailIcon from "@mui/icons-material/Email";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ContactPageIcon from "@mui/icons-material/ContactPage";

const navbarRoutes = [
  {
    name: "Acerca de nosotros",
    route: "/acerca-de-nosotros",
    icon: <ContactPageIcon />,
  },
  {
    name: "Especialidades",
    route: "/especialidades",
    icon: <MedicalServicesIcon />,
  },
  {
    name: "Casos de Éxito",
    route: "/casos-de-exito",
    icon: <AutoAwesomeIcon />,
  },
  {
    name: "Contacto",
    route: "/contacto",
    icon: <EmailIcon />,
  },
  {
    name: "promociones",
    icon: <AutoAwesomeIcon />,
    route: "/promociones",
  },
];

export default navbarRoutes;
